var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notifications',{attrs:{"position":"bottom right","animation-type":"css"}}),(_vm.$vuetify.breakpoint.width <= 980)?_c('TabletSidebar'):_c('sidebar'),_c('app-bar'),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }